module.exports = __webpack_public_path__ + "static/media/ticket-with-bg.08cc792f.svg";